import { addDefaultCountryCodeToPhoneNumber } from '@/app/(main)/air-request/utils/addDefaultCountryCodeToPhoneNumber';
import type { Nullable } from '@/types/common';

export type PrimaryPassengerContactSource = {
  email?: Nullable<string>;
  phone?: Nullable<string>;
};

export type InheritedUnderageContact = {
  email: string;
  phone: string;
};

export function getInheritedUnderageContact(
  primaryPassenger: PrimaryPassengerContactSource | null | undefined
): InheritedUnderageContact | null {
  if (!primaryPassenger) {
    return null;
  }

  const email = primaryPassenger.email ?? '';
  const phone = primaryPassenger.phone ? addDefaultCountryCodeToPhoneNumber(primaryPassenger.phone) : '';

  if (!email && !phone) {
    return null;
  }

  return { email, phone };
}
